import type { AxiosInstance, AxiosResponse } from 'axios';

type Method = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface HttpInterface {
  getServiceUrl(): string;
  getAxios(): AxiosInstance | null;
  send<Data, Params, Properties>(
    method: Method,
    url: string,
    data?: Data,
    headers?: object,
    params?: Params,
    properties?: Properties,
  ): Promise<AxiosResponse<unknown>>;
}

let sendInterface: HttpInterface['send'] = () => {
  throw new Error('initialize sendInterface with httpClientInterfaceInit first...');
};
let getServiceUrlInterface: HttpInterface['getServiceUrl'] = () => {
  throw new Error('initialize getServiceUrlInterface with httpClientInterfaceInit first...');
};
let getAxiosInterface: HttpInterface['getAxios'] = () => null;

export const httpClientInterfaceInit = ({ send, getServiceUrl, getAxios }: Partial<HttpInterface>) => {
  sendInterface = send || sendInterface;
  getServiceUrlInterface = getServiceUrl || getServiceUrlInterface;
  getAxiosInterface = getAxios || getAxiosInterface;
};

export const send: HttpInterface['send'] = (...params) => sendInterface?.(...params);
export const getServiceUrl: HttpInterface['getServiceUrl'] = () => getServiceUrlInterface?.();
export const getAxios: HttpInterface['getAxios'] = () => getAxiosInterface?.();
